
(function(){
  var TOP50_HANDLE = 'top-50';
  var topHandles = null;

  function ensureRelative(el){
    if (!el) return;
    var s = window.getComputedStyle(el);
    if (s.position === 'static') el.style.position = 'relative';
  }

  function addBadge(card, type, text){
    if (!card || card.querySelector('.booksy-card-badge--' + type)) return;
    var holder = card.querySelector('.grid__item-image-wrapper, .grid-product__image-wrapper, .grid-product__link, .grid-product__image-mask') || card;
    ensureRelative(holder);
    var span = document.createElement('span');
    span.className = 'booksy-card-badge booksy-card-badge--' + type;
    span.textContent = text;
    holder.appendChild(span);
  }

  function getProductHandleFromCard(card){
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function applyTopBadges(){
    if (!topHandles) return;
    var cards = document.querySelectorAll('.grid-product, .grid-product__wrapper, [data-grid-product]');
    cards.forEach(function(card){
      var handle = getProductHandleFromCard(card);
      if (handle && topHandles.indexOf(handle) !== -1) {
        addBadge(card, 'top', '🏆 Top eladott');
      }
    });
  }

  function applyNewBadges(){
    // Cards with data-product-tags containing 'new' / 'uj' / 'új'
    var cards = document.querySelectorAll('[data-product-tags]');
    cards.forEach(function(card){
      var raw = (card.getAttribute('data-product-tags') || '').toLowerCase();
      var tags = raw.split(/[,\s]+/);
      if (tags.indexOf('new') !== -1 || tags.indexOf('uj') !== -1 || tags.indexOf('új') !== -1) {
        addBadge(card, 'new', '🆕 Új');
      }
    });
  }

  function fetchTop50(){
    fetch('/collections/' + TOP50_HANDLE + '/products.json?limit=50', {credentials: 'same-origin'})
      .then(function(r){ return r.ok ? r.json() : {products: []}; })
      .then(function(data){
        topHandles = (data.products || []).map(function(p){ return p.handle; });
        applyTopBadges();
      })
      .catch(function(){ topHandles = []; });
  }

  function init(){
    fetchTop50();
    applyNewBadges();
    // Re-apply when Shopify section is re-rendered (e.g., filters, pagination)
    if (window.MutationObserver) {
      var deb = null;
      var obs = new MutationObserver(function(){
        if (deb) clearTimeout(deb);
        deb = setTimeout(function(){
          applyTopBadges();
          applyNewBadges();
        }, 200);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
